import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 2C6.47715 2 2 6.47715 2 12C2 13.5031 2.33228 14.9313 2.92835 16.2129C2.94023 16.2384 2.93961 16.2529 2.93944 16.2552L2.16111 19.4449C1.80913 20.8874 3.09629 22.197 4.54464 21.8699L7.87217 21.1185C7.87431 21.1184 7.88803 21.1179 7.91234 21.1288C9.16153 21.689 10.5458 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }